module.exports = __webpack_public_path__ + "static/img/tabletmain-survey-img.837febaa.svg";